module.exports = __webpack_public_path__ + "img/banner_Fabric.efe6eda5.jpg";